var switchPage = require('./switch-page.js')
var routes = {
	register: function () {/*  */},
	home: function () {
		switchPage('home')
		try {
			revapi.revnext()
		}
		catch (e) {}
	}
}

;
['feedback', 'about', 'contact', 'series', 'register'].forEach(function (name) {
	routes[name] = function () {
		switchPage(name)
	}
})

var embed = require('./yt-embed.js')
;
['tired', 'nervous', 'depressed', 'overwhelmed', 'angry', 'bullied', 'jealous', 'unappreciated', 'peaceful'].forEach(function (name) {
	routes[name] = function () {
		if (document.querySelector('[am-page-fragment="video-' + name + '"]') === null) {
			embed(name)
		}
		switchPage(name)
	}
})

routie(routes)

document.querySelectorAll('[am-href]').forEach(function (el) {
	el.addEventListener('click', function () {
		routie.navigate(el.getAttribute('am-href'))
	})
})
